import Link from 'next/link'
import React from 'react'
import styled from 'styled-components'

import ButtonPlay from '../../../components/ButtonPlay'
import Container from '../../../components/Container'
import UserImage from '../../../components/UserImage'
import { FONT_FAMILY_SECONDARY } from '../../../theme'
import { getLinkEntity, getLinkProfile } from '../../../utils/links'
import { MEDIA_QUERY_DESKTOP } from '../../../utils/media-query'
import AuctionInfo from './AuctionInfo'

const Component = styled.div`
  padding: 2rem 0;
  border-top: 1px solid rgba(255, 255, 255, .15);
  border-bottom: 1px solid rgba(255, 255, 255, .15);

  ${MEDIA_QUERY_DESKTOP} {
    padding: 6rem 0;
  }
`

const Content = styled.div`
  display: grid;
  grid-row-gap: 1rem;

  ${MEDIA_QUERY_DESKTOP} {
    display: grid;
    grid-template-columns: 1fr 2fr;
    grid-column-gap: 4rem;
  }
`

const VideoContainer = styled.div`
  position: relative;
  overflow: hidden;
  order: 1;

  ${MEDIA_QUERY_DESKTOP} {
    flex-grow: 1;
    order: 2;
  }
`

const Info = styled.div`
  order: 2;
  margin-top: 1rem;
  flex-shrink: 0;

  ${MEDIA_QUERY_DESKTOP} {
    margin-top: 0;
    order: 1;
  }
`

const Title = styled.div`
  font-size: 2rem;
  font-weight: 700;
  line-height: 1.2;
  font-family: ${FONT_FAMILY_SECONDARY};
  letter-spacing: -.5px;
  margin-bottom: 1rem;
  opacity: .95;
  color: white;

  ${MEDIA_QUERY_DESKTOP} {
    font-size: 3.5rem;
    max-width: 400px;
    margin-bottom: 2rem;
  }
`

const ArtistPill = styled.div`
  display: inline-flex;
  align-items: center;
  border-radius: 99px;
  padding: .5rem;
  border: 1px solid rgba(255, 255, 255, .15);
  cursor: pointer;
  color: white;
  margin-bottom: .5rem;

  ${MEDIA_QUERY_DESKTOP} {
    margin-bottom: 1.5rem;
  }
`

const ArtistName = styled.div`
  margin-left: .5rem;
  margin-right: .5rem;
  opacity: .75;
`

const LinkedAnchor = styled.a`
  color: white;

  &:hover {
    text-decoration: none;
  }
`

const Description = styled.div`
  opacity: .75;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 5; /* number of lines to show */
  line-clamp: 2;
  -webkit-box-orient: vertical;
  margin-bottom: 2rem;
`

const Video = styled.video`
  object-fit: cover;
  z-index: 1;
`

const VideoOverlay = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(0, 0, 0, .5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2;
`

const NewHomeHighlighted = ({ tokenMetadata, id }) => {
  const link = getLinkEntity({
    creatorUsername: tokenMetadata.creator.username,
    slug: tokenMetadata.slug
  })

  const artistLink = getLinkProfile({
    username: tokenMetadata.creator.username
  })

  return (
    <Component id={id}>
      <Container>
        <Content>
          <Info>
            <Link
              href={artistLink}
              passHref
            >
              <LinkedAnchor>
                <ArtistPill>
                  <UserImage
                    user={tokenMetadata.creator}
                    size={32}
                  />
                  <ArtistName>
                    @{tokenMetadata.creator.username}
                  </ArtistName>
                </ArtistPill>
              </LinkedAnchor>
            </Link>
            <Link
              href={link}
              passHref
            >
              <LinkedAnchor>
                <Title>
                  {tokenMetadata.name}
                </Title>
              </LinkedAnchor>
            </Link>
            <Description>
              {tokenMetadata.description}
            </Description>
            <AuctionInfo tokenMetadata={tokenMetadata} />
          </Info>
          <VideoContainer>
            <Video
              src={tokenMetadata.videoPreviewUri}
              autoPlay
              muted
              loop
              width='100%'
              height='100%'
              playsInline
            />
            <VideoOverlay>
              <Link
                href={link + '?play=true'}
                passHref
              >
                <a>
                  <ButtonPlay>
                    Play
                  </ButtonPlay>
                </a>
              </Link>
            </VideoOverlay>
          </VideoContainer>
        </Content>
      </Container>
    </Component>
  )
}

export default NewHomeHighlighted
